import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Overlay, ModalContainer, ModalHeader, ModalBody, ModalFooter } from './components/ModalStyles';
import { useModal } from './hooks/useModal';
import { buildModalAriaProps } from './utils/modalHelpers';
import IconButton from '../../atoms/IconButton';
import Button from '../../atoms/Button';

let portalRoot = null;
if (typeof document !== 'undefined') {
  portalRoot = document.getElementById('modal-root');
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.setAttribute('id', 'modal-root');
    document.body.appendChild(portalRoot);
  }
}

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  size,
  primaryAction,
  secondaryAction,
  loading 
}) => {
  const { handleOverlayClick } = useModal({ isOpen, onClose });

  if (!isOpen || !portalRoot) return null;

  const ariaProps = buildModalAriaProps(title);

  return ReactDOM.createPortal(
    <Overlay onClick={handleOverlayClick}>
      <ModalContainer size={size} {...ariaProps}>
        <ModalHeader>
          {title && <h2 id="modal-title">{title}</h2>}
          <IconButton icon="times" onClick={onClose} ariaLabel="Close Modal" />
        </ModalHeader>
        
        <ModalBody>
          {children}
        </ModalBody>
        
        {(primaryAction || secondaryAction) && (
          <ModalFooter>
            {secondaryAction && (
              <Button 
                variant="text" 
                onClick={secondaryAction.onClick} 
                disabled={loading || secondaryAction.disabled}
              >
                {secondaryAction.label}
              </Button>
            )}
            {primaryAction && (
              <Button 
                variant="primary" 
                onClick={primaryAction.onClick} 
                loading={loading}
                disabled={primaryAction.disabled}
              >
                {primaryAction.label}
              </Button>
            )}
          </ModalFooter>
        )}
      </ModalContainer>
    </Overlay>,
    portalRoot
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  loading: PropTypes.bool,
  primaryAction: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }),
  secondaryAction: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }),
};

Modal.defaultProps = {
  title: undefined,
  size: 'md',
  loading: false,
  primaryAction: undefined,
  secondaryAction: undefined,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/design-system/molecules/Modal/Modal.jsx